<template>
  <v-layout :class="styles" column>
    <v-menu transition="slide-y-transition" top>
      <template v-slot:activator="{ on }">
        <p class="ma-0 px-4 notifyTitle">
          <a v-on="on">
            [お知らせ] GW期間の休業に伴う各種スケジュールについて
          </a>
        </p>
      </template>
      <v-card class="pa-2">
        <v-subheader :class="[headerStyles, 'px-2']">
          [お知らせ] GW期間の休業に伴う各種スケジュールについて
        </v-subheader>
        <p class="ma-2">
          平素よりご利用いただきありがとうございます。<br />
          誠に勝手ながら、下記の期間につきましてゴールデンウィーク休業に伴い、各種業務を休止いたします。<br />
          <br />
          休業期間：<br />
          2024年4月27日(土)〜2024年4月29日（月）<br />
          2024年5月2日(木)〜2024年5月6日（月）<br />
          ※2024年5月2日(木)は会社の定める一斉休業日になります。<br />
          <br />
          停止する業務<br />
          ・予算承認業務<br />
          ・各種運用サポート業務<br />
          ・マネージドメニューの入稿業務（動画・音声クリエイティブの入稿代行業務含む）<br />
          ・運用代行業務<br />
          <br />
          上記に伴い、各種入稿スケジュールについて締め切り期限を設定しております。<br />
          詳しくは、<a
            href="https://geologic.atlassian.net/wiki/spaces/GLAD/blog/2024/03/28/2778529813/2024"
            target="_blank"
            rel="noopener noreferrer"
            >こちら</a
          >
          にてご確認をお願いします。<br />
          お手数ですが、ご確認の上、期日に間に合うスケジュールにてご入稿、運用依頼のご手配をいただけますようご協力をお願いいたします。
        </p>
        <AppButtonOk small>閉じる</AppButtonOk>
      </v-card>
    </v-menu>
  </v-layout>
</template>

<script>
import { css } from 'emotion'
import dayjs from 'dayjs'

export default {
  name: 'HolidaysInformation',
  computed: {
    styles() {
      return css`
        display: flex;
        align-items: flex-start;
        justify-content: center;
        font-size: 12px;
        overflow: hidden;
      `
    },
    headerStyles() {
      return css`
        font-size: 16px !important;
      `
    },
  },
  methods: {
    isBefore(datetime) {
      return dayjs().isBefore(datetime)
    },
  },
}
</script>

<style scoped>
.notifyTitle {
  font-size: 14px;
}
</style>
